import { render, staticRenderFns } from "./ReviewWriteDialog.vue?vue&type=template&id=584eb5ad"
import script from "./ReviewWriteDialog.vue?vue&type=script&lang=js"
export * from "./ReviewWriteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports